import { SharedAppSettings } from '@luggagehero/shared/app-settings/data-access';
import { AddressFormat } from '@luggagehero/shared/interfaces';

export const DefaultAppSettings: Partial<SharedAppSettings> = {
  isEmailOtpEnabled: true,
  maxTimeMinutesPinReuse: 10,
  minTimeSecondsPinRefresh: 3,
  premiumInsuranceEnabled: true,
  // The booking wizard's Premium tier ships ON (AM-4345) so the coverage-tier split test runs from the
  // first deploy. Set `false` from the `appsettings` collection to withdraw it without a release.
  //
  // The prices it offers are a per-market decision and are NOT settled by this flag: AM-4619 tracks four
  // production contexts (WW B2C, SE, NO, AR) where Premium currently costs *less* than Basic. Those must be
  // repriced before this deploys — where the pair is inverted the Premium card is hidden and the server
  // refuses the tier, so the traveler is never mis-sold, but the experiment silently does not run there
  // (and WW is the fallback context).
  //
  // Separate from `premiumInsuranceEnabled` above, which is the hotel-guest coverage step's own switch.
  bookingWizardPremiumInsuranceEnabled: true,
  storageLocationsWithWallMountedKeypad: [
    '678670859f7595a3767a7f62', // Bunks at Rode
  ],
  keypadConfirmSymbols: ['↵', '#'],
  isBookingInsuranceSelectedByDefault: true,
  isDropoffInsuranceSelectedByDefault: false,
  defaultNumberOfHoursUsedForPaymentValidation: 2,
  bookingStatusesWithAccessInfoEnabled: ['CHECKED_IN', 'CHECKED_OUT', 'PAID'],
  defaultAddressFormat: AddressFormat.Formatted,
  // AM-4637 / AM-4661 — the booking wizard's storage cards price a SINGLE BAG ("$4.50/bag/day").
  // Set `true` via the `appsettings` collection to price the whole booking instead ("$9/day" for
  // 2 bags, dropping the `/bag` segment) without a release. Wizard flows only — the guest drop-off
  // step does not read this.
  bookingWizardAccumulatedStorageRate: false,
  // AM-4653 — booking-wizard presentation, all three shipped ON so the staging round shows the
  // arrangement the feedback asked for without a settings flip. Each is independently reversible from
  // the `appsettings` collection (per `appName` — both traveler apps need a row), which is the point:
  // these are framing decisions, and framing gets argued about after people see it.
  //   - bookingWizardCoverageSkipLink: decline coverage via a quiet link below the cards, not a
  //     third card among them.
  //   - bookingWizardServiceFeeNote: state the per-bag service fee under each storage card's price.
  //   - bookingWizardFreeCancellationBanner: carry the free-cancellation reassurance on every step.
  bookingWizardCoverageSkipLink: true,
  bookingWizardServiceFeeNote: true,
  bookingWizardFreeCancellationBanner: true,
  // Declining coverage asks for confirmation, as the hotel-guest drop-off flow does.
  bookingWizardConfirmNoCoverage: true,
  // The insurance step opens with nothing selected (AM-4919); `basic` preselects Basic for the
  // pre-booking split test's second run, set per app in the `appsettings` collection, not here.
  bookingWizardCoverageDefault: 'none',
};
